/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-29 18:05:23
 * @LastEditTime: 2022-01-29 18:45:01
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账 - 惠市宝对账单汇总列表 - 汇总数据订单明细数据
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/HSBList/components/WFTInfoList.jsx
 */

import React, { useState, useRef } from 'react'
import { Button, Modal } from 'antd';
import TableHelper from '../../../../components/TableHelper';
import { fetchPlatformRecordWftPayOrderSummaryDataOrderList } from '../../../../services/platformAccountingRecord';
import ModalScrollContainer from '../../../../components/ModalScrollContainer';
import { findDict, formatTime } from '../../../../utils';
import WFTInfoDetail from './WFTInfoDetail';




const WFTInfoList = (props) => {
    const [visible, setVisible] = useState(false);
    const [tradeDate, setTradeDate] = useState(null);
    let HSBInfoDetailRef = useRef()
    const open = (tradeDate) => {
        setTradeDate(tradeDate)
        setVisible(true)
    }
    const close = () => {
        setVisible(false)
    }
    props.getRef && props.getRef({ open });
    const columns = [
        { title: '商户名称', dataIndex: 'merchantName', width: 150 },
        { title: '商户订单号', dataIndex: 'merchantOrderNumber', width: 130 },
        { title: '交易金额', dataIndex: 'tradeAmount',width: 100 },
        { title: '手续费', dataIndex: 'serviceCharge', width: 70},
        { title: '手续费比例', dataIndex: 'rate',width: 100 },
        { title: '结算金额', dataIndex: 'settlementAmount',width: 100 },
        { title: '交易时间', dataIndex: 'tradeDateTime', render: (text) => formatTime(text, 'YYYY-MM-DD HH:mm')},
        { title: '创建时间', dataIndex: 'updateTime',width: 140, render: formatTime},
        { title: '操作', dataIndex: 'actions', width: 70, fixed: 'right', render: (text, record) => {
            return <a onClick={() => HSBInfoDetailRef.open(record.id)}>详情</a>
        } }
    ]
    const parseRequestData = (data) => {
        data.tradeDate = tradeDate
        return data
    }
    return (
        <Modal
            visible={visible}
            width={950}
            title="汇总数据订单明细数据"
            destroyOnClose
            footer={<Button onClick={close}>关闭</Button>}
            onCancel={close}
        >
            <ModalScrollContainer>
                {tradeDate && (
                    <TableHelper
                        columns={columns}
                        scroll={{x: 1100}}
                        parseRequestData={parseRequestData}
                        request={fetchPlatformRecordWftPayOrderSummaryDataOrderList}
                    />
                )}

            </ModalScrollContainer>
            <WFTInfoDetail getRef={ref => HSBInfoDetailRef = ref} />
        </Modal>
    )
}

export default WFTInfoList


// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/WFTList/components/WFTInfoList.jsx